import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue } from "recoil";
import { Button } from 'components/ui';
import * as yup from "yup";
import { OfficeAddressState, UserState } from "../../appState";
import { SvgIconConfig } from "../../config";
import { UrlConfig } from "../../config/urlConfig";
import { AppData } from "../../data";
import { AlertTypeEnum, CodeEnum, PersonalAddressEnum } from "../../enum";
import { Resource } from "../../resource";
import { ApiTool, AppTool, LocationTool } from "../../tool";
import Dialog from "../dialog/dialog";
import DialogAction from "../dialogAction/dialogAction";
import DialogBody from "../dialogBody/dialogBody";
import DialogHeader from "../dialogHeader/dialogHeader";
import SuggestV3 from "../suggestV3/suggestV3";
import TextView from "../textView/textView";
import "./userWorkAddressInput.scss";

const IconDict = {
  place: SvgIconConfig.direction.suggestPoi.place,
  history: SvgIconConfig.direction.suggestPoi.history,
};

const getTextInput = (poi) => {
  let text = poi?.name && poi?.address ? `${poi?.name}, ${poi?.address}` : (poi?.name || poi?.address)
  if (text && poi?.name === ("Cơ quan" || "Work")) {
    text = poi?.placeName && poi?.address ? `${poi?.placeName}, ${poi?.address}` : (poi?.placeName || poi?.address)
  }
  if (!text) {
    text = poi?.location ? `${poi?.location.lat().toFixed(6)}, ${poi?.location.lng().toFixed(6)}` : ""
  }
  return text
}

function UserWorkAddressInput({ onChange, onClose }) {
  const [officeAddressState, setOfficeAddressState] = useRecoilState(
    OfficeAddressState
  );
  const schema = yup.object().shape({
    poi: yup
      .mixed()
      .nullable()
      .test(
        "required",
        Resource.formatString(Resource.validate.required, {
          field: Resource.common.address,
        }),
        function (poi) {
          if (!poi && !officeAddressState) {
            return false;
          }
          return true;
        }
      ),
  });

  const { register, handleSubmit, errors, setValue, formState } = useForm({
    resolver: yupResolver(schema),
  });

  const [poiState, setPoiState] = useState();
  const [listPoiState, setListPoiState] = useState([]);
  const [error, setError] = useState(false);
  const user = useRecoilValue(UserState)

  useEffect(() => {
    setPoiState(officeAddressState);
  }, [officeAddressState]);

  const handleOnchange = (newPoi) => {
    setError(false)
    setValue("poi", newPoi, { shouldValidate: formState.isSubmitted });
    setPoiState(newPoi);
  };

  const handleClose = () => {
    onClose && onClose();
  };

  const userWorkAddress = Resource.common.office;

  const handleSave = (data) => {
    if (poiState) {
      if (poiState?.location) {
        let body = {
          placeId: poiState?.id ? poiState?.id : "",
          address: poiState?.address,
          location: poiState?.location,
          updateType: PersonalAddressEnum.office,
          name: poiState?.name,
        };
        ApiTool.post(
          UrlConfig.userLabel.update,
          body,
          (res) => {
            if (res?.code == CodeEnum.ok) {
              let dataHome = {
                ...res?.result?.company,
                name: Resource.common.office,
              };
              setOfficeAddressState(dataHome);
              AppTool.alert(
                Resource.formatString(
                  officeAddressState
                    ? Resource.alert.success.editAddress
                    : Resource.alert.success.saveAddress,
                  {
                    object: userWorkAddress.toLowerCase(),
                  }
                ),
                AlertTypeEnum.success
              );
              onChange && onChange(res?.result?.company);
            } else {
              AppTool.alert(
                Resource.formatString(
                  officeAddressState
                    ? Resource.alert.error.editAddress
                    : Resource.alert.error.saveAddress,
                  {
                    object: userWorkAddress.toLowerCase(),
                  }
                ),
                AlertTypeEnum.error
              );
            }
            onClose && onClose();
          },
          true
        );
      }
    } else {
      ApiTool.delete(
        UrlConfig.userLabel.delete.replace(
          "{userLabelType}",
          PersonalAddressEnum.office
        ),
        (res) => {
          if (res?.code == CodeEnum.ok) {
            setOfficeAddressState(null);
            AppTool.alert(
              Resource.formatString(Resource.alert.success.delete, {
                object: userWorkAddress.toLowerCase(),
              }),
              AlertTypeEnum.success
            );
            onChange && onChange(res?.result?.company);
          } else {
            AppTool.alert(
              Resource.formatString(Resource.alert.error.delete, {
                object: userWorkAddress.toLowerCase(),
              }),
              AlertTypeEnum.error
            );
          }
          onClose && onClose();
        },
        true
      );
    }
  };

  register({ name: "poi", type: "custom" });

  useEffect(() => {
    getListPoi();
  }, []);

  const selectOptionMatchTextPercent = (suggests) => {
    if (suggests?.length == 1) {
      setPoiState(suggests[0])
    }
    else {
      setError(true)
    }
  }

  const getListPoi = (keyword = "", isEnter = false) => {
    let locationNew = AppData.map?.getCamera()?.getCenter();
    let locString = `${locationNew?.lat},${locationNew?.lng}`;
    let body = {
      text: keyword,
      location: locString,
      isEnter: isEnter
    };
    let param = {
      count: 5,
      isPlace: true,
    };
    if (keyword == "" && user?.id) {
      ApiTool.queryGetFromJson(
        UrlConfig.searchHistory.get,
        param,
        (res) => {
          if (res?.code == CodeEnum.ok) {
            let list = res?.result?.map((value) => {
              let val = { ...value?.place };
              val.isHistory = true;
              val.id = val?.placeId;
              return val;
            });
            setListPoiState(list);
          }
        },
        true
      );
    } else {
      ApiTool.queryGetFromJson(
        UrlConfig.poi.autosuggest,
        body,
        (res) => {
          if (res?.code == CodeEnum.ok) {
            let data = res?.result?.splice(0, 5);
            setListPoiState(data);
            if (isEnter) {
              selectOptionMatchTextPercent(data)
            }
            else {
              setError(false)
              setListPoiState(data) || []
            }
          }
        },
        true
      );
    }
  };

  const onChangeTextInput = (keyword) => {
    getListPoi(keyword);
  };

  const getOptionLabel = (option) => {
    return getTextInput(option)
  };
  const renderOption = (option) => {
    return (
      <div key={option?.id} style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ marginRight: "14px", width: "24px", height: "24px" }}>
          {option?.isHistory == true ? IconDict.history : IconDict.place}
        </div>
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {getTextInput(option)}
        </div>
      </div>
    );
  };
  const onSearchEnter = (text, isEnter) => {
    let position = LocationTool.checkTextIsLocation(text)
    if (position) {
      getAddressFromLocation(position)
    }
    else {
      getListPoi(text, isEnter)
    }
  }

  const getAddressFromLocation = (location) => {
    ApiTool.queryGetFromJson(UrlConfig.geocode.geocode, location, (res) => {
      if (res?.code == CodeEnum.ok) {
        setPoiState(res?.result)
      }
    })
  }

  return (
    <Dialog open={true} onClose={handleClose} className="userWorkDialog" disableCloseOnClickBackdrop>
      <form onSubmit={handleSubmit(handleSave)}>
        <DialogHeader className="userWorkTitle">
          {Resource.formatString(Resource.personalAddress.updateAddress, {
            object: userWorkAddress.toLowerCase(),
          })}
        </DialogHeader>
        <DialogBody className="userWorkContent">
          <SuggestV3
            label={Resource.common.search}
            placeholder={Resource.address.add}
            options={listPoiState}
            value={poiState}
            onChange={handleOnchange}
            onInputChange={onChangeTextInput}
            maxLengthOfScroll={6}
            isServer
            isFreeSolo
            clearable
            getTextForOption={getOptionLabel}
            renderOption={renderOption}
            onEnter={onSearchEnter}
            error={error}
            helperText={error ? Resource.direction.errorMessage.homeOrWork : null}
          />
        </DialogBody>
        <DialogAction className="userWorkAction">
          <TextView variant="caption">{error}</TextView>
          <div
            style={{
              display: "flex",
            }}
          >
            <Button variant="close" onClick={handleClose}>
              {Resource.button.cancel.toUpperCase()}
            </Button>
            <Button variant="save" type="submit">
              {Resource.button.save.toUpperCase()}
            </Button>
          </div>
        </DialogAction>
      </form>
    </Dialog>
  );
}

UserWorkAddressInput.propTypes = {
  //
  onChange: PropTypes.any,
  onClose: PropTypes.any,
};

export default UserWorkAddressInput;
